import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconOk(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={62.59}
          y1={57.08}
          x2={45.58}
          y2={40.07}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <linearGradient
          id={`${iconUuid}_b`}
          x1={78.35}
          y1={77.89}
          x2={22.11}
          y2={21.65}
          xlinkHref={`#${iconUuid}_a`}
        />
      </defs>
      <path
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M44.72,74.63a.74.74,0,0,1-.57-.27L29.09,56.56l1.14-1,14.37,17L69.82,29.12l1.29.75L45.37,74.26a.74.74,0,0,1-.58.37Z"
      />
      <path
        fill={`url(#${iconUuid}_b)`}
        stroke={`url(#${iconUuid}_b)`}
        strokeWidth={5}
        d="M50.23,11.5A38.27,38.27,0,1,1,12,49.77,38.32,38.32,0,0,1,50.23,11.5m0-1.5A39.77,39.77,0,1,0,90,49.77,39.77,39.77,0,0,0,50.23,10Z"
      />
    </svg>
  );
}
export default SvgEchIconOk;
